<template>
  <div>
    <FimButton
      type="raw"
      no-padding
      is-small
      class="!whitespace-normal font-normal underline decoration-1 underline-offset-4 hover:text-shade-400"
      @click="onClick"
    >
      <template #icon>
        <LazyIconFielmannQuestionBubble class="size-5" />
      </template>
      {{ text }}
    </FimButton>
  </div>
</template>

<script setup lang="ts">
defineProps({
  text: {
    type: String as PropType<string>,
    required: true,
  },
})

const emit = defineEmits(['click'])

const onClick = () => {
  emit('click')
}
</script>
